import Link from 'next/link';
import { DEFAULT_FULL_LOGO_SRC } from 'utils';

const IntroSection = () => (
  <section id="intro" className="bg-[#317E70]">
    <div className='container mx-auto py-10'>
      <div className='mx-auto'>
        <img className='mx-auto w-40 md:w-60' src={DEFAULT_FULL_LOGO_SRC} alt="Escape Bar Logo" />
      </div>
      <div className='p-8 text-white text-lg font-bold flex flex-col gap-y-6 leading-9'>
        <p>　　歡迎來到第四屆年度實境遊戲選拔賽－金逃獎－【金逃影展】！</p>
        <p>　　為促進實境遊戲產業進步與活絡，逃脫吧 - Escapebar 以建立實境遊戲業者以及廣大玩家連結為宗旨，於 2022 年首次舉辦「<Link href="/event/goty2021" className="text-[#DFB750] no-underline">2021年度實境遊戲選拔賽</Link>」票選活動，邀請廣大熱愛實境遊戲的玩家票選出前一年度最佳遊戲主題，給予遊戲創作者鼓勵，並期待國內的實境遊戲創作者與經營者以獲獎為目標，持續投入兼具創新與創意的遊戲創作。</p>
        <p>　　在前三屆的活動中，金逃獎籌備小組試圖在每一屆都做些許改變，包含票選方式、獎項設立、評選標準、投票時程等，試圖找出最適當且公允的評選方式。在第三屆的獎項中我們提出了實境遊戲良窳六維，並且因應 2023 年恐怖主題的趨勢，將「恐怖氣氛」獨立出一個獎項。</p>
        <p>　　而 2024 年我們觀察到代理遊戲以及沉浸式劇場的風氣開始盛行，因此在本屆賽事中新增了「沉浸式劇場」、「代理遊戲」兩個獎項。而為了不讓實境解謎以及本格密室的風采被埋沒，我們也將「實境解謎」獨立出一個獎項，更新增了「精粹密室」獎項以彰顯本格密室逃脫之美。加上第三屆既有的九個獎項，本屆新設四項，共設立十三項。</p>
        <p>　　實境遊戲在台灣萌芽十二年後的今天，遊戲型態的多樣化以及代理內容的與日俱增，玩家的遊戲選擇越來越豐富，好比電影一般。此一想法，讓活動主題【金逃影展】應運而生，我們非常期待本屆各式主題的交匯將激盪出什麼樣的火花。本屆活動不如往年在第一季舉行，目的是希望讓玩家有更充足的時間遊玩 2024 年的遊戲後再進行投票。請大家踴躍表態，支持自己心目中最佳的年度最佳遊戲吧！</p>
      </div>
    </div>
  </section>
);

export default IntroSection;